import React from 'react';
import TutorForm from '../../../components/forms/TutorForm';

export default function TutorsCreatePage() {
  return <TutorForm />;
}
